import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { Form, Col, Row, Button, Alert } from "react-bootstrap";
import water_logo_medium from "../../../images/water_logo_medium.png";
import SessionHelper from "../../../helpers/SessionHelper";
import StorageHelper from "../../../helpers/StorageHelper";
import AuthHelper from "../../../helpers/AuthHelper";
import {
  ENTER_USERNAME,
  INVALID_CREDENTIALS,
  PLEASE_ENTER_PASSWORD,
  SESSION_HAS_EXPIRED,
} from "../../../configurations/MessageConstants";
import { Navigate } from "react-router-dom";
import {
  DANGER,
  EMPTY,
  LOGGING_IN,
  LOGIN,
  STAFF,
  STAFF_SESSION_EXPIRED,
  USER_POOL_GROUP,
} from "../../../configurations/Constants";

function StaffLogin(props) {
  const [username, setUsername] = useState(EMPTY);
  const [password, setPassword] = useState(EMPTY);
  const [redirect, setRedirect] = useState(false);
  const [showpassword, setShowpassword] = useState(false);
  const [validated, setValidated] = useState(false);
  const [invalidCredError, setInvalidCredError] = useState(false);
  const [btnLoginClick, setBtnLoginClick] = useState(false);
  const [errorMessage, setErrorMessage] = useState(INVALID_CREDENTIALS);

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "username") setUsername(value);
    else if (name === "password") setPassword(value);
  };

  const handleStaffLogin = async (event) => {
    StorageHelper.setItem(USER_POOL_GROUP, STAFF);
    SessionHelper.cleanUpStorageKeys();
    setBtnLoginClick(true);
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      setBtnLoginClick(false);
    } else {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false);
      try {
        await AuthHelper.SignIn(username.toLowerCase().trim(), password, true);
        StorageHelper.setItem(LOGGING_IN, LOGIN + Math.random());
        StorageHelper.removeItem(LOGGING_IN);
        StorageHelper.removeItem(STAFF_SESSION_EXPIRED);
        if (props.CheckStaffLoggedIn) props.CheckStaffLoggedIn(true);
        setRedirect(true);
      } catch (error) {
        setErrorMessage(INVALID_CREDENTIALS);
        setInvalidCredError(true);
        setBtnLoginClick(false);
      }
    }
  };

  const toggleShowPassword = () => {
    setShowpassword(!showpassword);
  };
  const handleClose = () => {
    props.closeLoginModal();
  };

  if (redirect) {
    const redirectTo = props.redirectTo || "/well-test-form";
    return <Navigate to={redirectTo} />;
  }

  return (
    <Modal
      show={props.showStaffLogin}
      onHide={handleClose}
      className="staff-login-modal"
    >
      <div className="d-flex p-5 align-items-center justify-content-center flex-column">
        {StorageHelper.getItem(STAFF_SESSION_EXPIRED) === "true" && (
          <Alert variant={DANGER} onClose={() => setInvalidCredError(false)}>
            {SESSION_HAS_EXPIRED}
          </Alert>
        )}
        <figure className="text-center mt-2">
          <img
            src={water_logo_medium}
            className="staff-login-logo"
            alt="Logo"
          />
        </figure>
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleStaffLogin(e)}
          className="mt-3 w-100"
        >
          {invalidCredError && (
            <Alert
              variant={DANGER}
              onClose={() => setInvalidCredError(false)}
              dismissible
            >
              {errorMessage}
            </Alert>
          )}
          <Form.Group as={Row} className="mb-3" controlId="validationUsername">
            <Col>
              <Form.Control
                type="email"
                placeholder="Email"
                name="username"
                onChange={handleOnChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_USERNAME}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            className="mb-3"
            controlId="formPlaintextPassword"
          >
            <Col>
              <Form.Control
                type={showpassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                onChange={handleOnChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                {PLEASE_ENTER_PASSWORD}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintext">
            <Col>
              <Form.Check
                type="checkbox"
                label="Show Password"
                onChange={() => {
                  toggleShowPassword();
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintext">
            <Col>
              <Button variant="primary" onClick={handleClose}>
                Close
              </Button>
              <Button type="submit" className="m-2" disabled={btnLoginClick}>
                {btnLoginClick ? (
                  <div>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    <span>Login...</span>
                  </div>
                ) : (
                  "Login"
                )}
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </Modal>
  );
}

export default StaffLogin;
